import { gql } from "@apollo/client";
import ShareDialog from "@src/features/libraryItem/course/shareButton/ShareDialog";
import { useTrainingResourceSharingPermissionsQuery } from "@src/features/libraryItem/course/shareButton/ShareTrainingResourceDialog.generated";
import { FC } from "react";
import useContentPermissions from "@src/features/libraryItem/hooks/useContentPermissions";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  trainingResourceId: string;
};

const ShareTrainingResourceDialog: FC<Props> = ({
  open,
  onOpenChange,
  trainingResourceId,
}) => {
  const permissions = useContentPermissions({ trainingResourceId });
  const { data } = useTrainingResourceSharingPermissionsQuery({
    variables: {
      id: trainingResourceId,
    },
  });
  const trainingResource = data?.TrainingResource;
  if (!trainingResource) {
    return null;
  }
  return (
    <ShareDialog
      open={open}
      onOpenChange={onOpenChange}
      trainingResource={trainingResource}
      hasEditAdminAndManagerSharingPermission={
        !!permissions?.hasEditAdminAndManagerSharingPermission
      }
      hasShareWithIndividualsPermission={
        !!permissions?.hasShareWithIndividualsPermission
      }
    />
  );
};

export default ShareTrainingResourceDialog;

gql`
  query TrainingResourceSharingPermissions($id: String!) {
    TrainingResource: AdminTrainingResource(id: $id) {
      ...TrainingResourceSharingPermissionsTrainingResource
    }
  }

  fragment TrainingResourceSharingPermissionsTrainingResource on TrainingResource {
    id
    libraryItem {
      id
      sharingPermissions {
        ...ContentSharingPermission
      }
      createdBy {
        id
      }
    }
  }
`;
